module.exports = __webpack_public_path__ + "img/视频场景_vlog剪辑.40260dec.png";